// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__dP8ai","description":"About_description__dltyT"};